import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button from 'components/button/Button';
import { TriggerConditionsContainer } from '../../TriggersTab.styles';
import { TriggerAddEditModalFormValues } from '../TriggerAddEditModal.schema';
import { buildCondition } from '../TriggerAddEditModal.utils';
import { useTriggerAddEditModalContext } from '../TriggerAddEditModalContext';
import TriggerAddEditModalChooseConditionField from './TriggerAddEditModalChooseConditionField';
import useAvailableConditions from './useAvailableConditions';

const TriggerAddEditModalConditionsField = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<TriggerAddEditModalFormValues>();
  const conditions = useWatch({ control, name: 'conditions' });
  const { conditionsFieldArray } = useTriggerAddEditModalContext();
  const { append, fields, remove } = conditionsFieldArray;
  const availableConditions = useAvailableConditions();

  const handleAddConditionClick = () => {
    append(buildCondition({ conditionType: '' }));
  };

  if (!availableConditions?.length) {
    return null;
  }

  const hasConditionTypeNotSelected = conditions?.some(
    ({ conditionType }) => !conditionType,
  );

  const hasAllConditionTypesSelected =
    conditions?.map(({ conditionType }) => conditionType).filter(Boolean)
      .length === availableConditions.length;

  return (
    <TriggerConditionsContainer>
      <span>{t('pageAutomations.triggers.ifTheseConditionsAreMet')}</span>
      {fields.map(({ id }, index) => (
        <TriggerAddEditModalChooseConditionField
          index={index}
          key={id}
          onRemoveClick={() => remove(index)}
        />
      ))}
      <Button
        bsStyle="link"
        data-testid="add-condition-button"
        disabled={hasConditionTypeNotSelected || hasAllConditionTypesSelected}
        onClick={handleAddConditionClick}
      >
        {t('pageAutomations.triggers.modal.addCondition')}
      </Button>
    </TriggerConditionsContainer>
  );
};

export default TriggerAddEditModalConditionsField;
